import { Component, input, output } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-settings-row-slide',
  templateUrl: './settings-row-slide.component.html',
  styleUrls: ['./settings-row-slide.component.scss'],
  standalone: false,
})
export class SettingsRowSlideComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly value = input<boolean>();
  readonly tooltip = input<string>();
  readonly disabled = input<boolean>();
  readonly hasPermission = input<boolean>(true);
  readonly label = input<string>();

  readonly valueChange = output<boolean>();
}
